import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BookOpen, Brain, Users, Sparkles } from 'lucide-react';

const modes = [
  {
    id: 'story',
    title: 'Story Time',
    description: 'Create stories together with your AI character',
    icon: BookOpen,
    color: 'from-pink-400 to-red-400',
  },
  {
    id: 'trivia',
    title: 'Trivia',
    description: 'Test your knowledge with fun questions',
    icon: Brain,
    color: 'from-blue-400 to-cyan-400',
  },
  {
    id: 'family',
    title: 'Family Chat',
    description: 'Chat about topics with your AI friend',
    icon: Users,
    color: 'from-green-400 to-emerald-400',
  },
  {
    id: 'adventure',
    title: 'Adventure',
    description: 'Go on exciting quests and missions',
    icon: Sparkles,
    color: 'from-purple-400 to-pink-400',
  },
];

export default function GameModes() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-300 via-purple-300 to-pink-300 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-2">Choose a Game Mode</h1>
          <p className="text-white/80">Pick how you want to play!</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {modes.map((mode) => {
            const Icon = mode.icon;
            return (
              <Card
                key={mode.id}
                className="p-6 cursor-pointer hover:shadow-lg transition-all transform hover:scale-105 bg-white/95 backdrop-blur"
                onClick={() => navigate(`/characters?mode=${mode.id}`)}
              >
                <div
                  className={`inline-flex p-3 rounded-lg bg-gradient-to-br ${mode.color} mb-4`}
                >
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">{mode.title}</h3>
                <p className="text-gray-600 mb-4">{mode.description}</p>
                <Button className="w-full bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white">
                  Play {mode.title}
                </Button>
              </Card>
            );
          })}
        </div>

        <Button
          variant="outline"
          className="w-full"
          onClick={() => window.history.back()}
        >
          Back
        </Button>
      </div>
    </div>
  );
}
